import React from 'react'
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { LiveSessionRoutes } from './Constants/routes';

const LiveSessionsAll = () => {
  const match = useRouteMatch();

  return (
    <>
      <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
      {LiveSessionRoutes.map(({ path, Component, exact, id }) => (
           <Route
             path={`${match.url}${path}`}
             exact={exact}
             component={Component}
             key={id}
           />
         ))}
         <Redirect to="/dashboard/live-sessions" />
      </Switch>
    </>
  )
}

export default LiveSessionsAll;